import Swal from "sweetalert2";

export const ErrorSessionNoLongerExists = (userName) => {
  return Swal.fire({
    title:
      "<span>" +
      userName +
      "" +
      "<p style='font-size: 16px;'>Error: A request was received from a session that no longer exists </p>",
    type: "error",
    icon: "error",
    timer: 2000,
    showConfirmButton: false,
  });
};
